import { useState } from "react";
import {
    Container,
    Col,
    Row
} from "reactstrap";
import styles from './styles.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const getEmbedUrl = (url) => {
	if (!url) return "";

	// YouTube (supports watch?v=, youtu.be/, shorts)
	const ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([^&?/]+)/);
	if (ytMatch) {
		return `https://www.youtube.com/embed/${ytMatch[1]}`;
	}

	// Vimeo
	const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
	if (vimeoMatch) {
		return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
	}

	// fallback
	return url;
};

const getYouTubeThumbnail = (url) => {
	if (!url) return null;
	const ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([^&?/]+)/);
	if (ytMatch) return `https://img.youtube.com/vi/${ytMatch[1]}/maxresdefault.jpg`;
	return null;
};

export const CarouselBlogDetail = ({
    topContent,
    items,
    bottomContent,
    className = "",
}) => {
    const [swiper, setSwiper] = useState(null);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const [playingSlides, setPlayingSlides] = useState(new Set());

    const handlePlay = (index) => {
        setPlayingSlides(prev => new Set([...prev, index]));
    };
    const hasMultiple = items && items.length > 1;

    const onSlideChange = (s) => {
        setIsBeginning(s.isBeginning);
        setIsEnd(s.isEnd);
    };

    return (
        <section className={`${styles.root} ${className}`}>
            <Container>
                <Row>
                    <Col md={12}>
                        {topContent &&
                            <div className="description" dangerouslySetInnerHTML={{ __html: topContent }} />
                        }
                        {items && items.length > 0 &&
                            <div className={styles.carouselWrapper}>
                                {hasMultiple && (
                                    <button
                                        className={`${styles.prevBtn} ${isBeginning ? styles.navHidden : ''}`}
                                        onClick={() => swiper?.slidePrev()}
                                        aria-label="Previous slide"
                                    >
                                        <img src="/site-assets/images/slide-button.png" alt="Previous" className={styles.prevBtnImg} />
                                    </button>
                                )}
                                <Swiper
                                    onSwiper={setSwiper}
                                    onSlideChange={onSlideChange}
                                    slidesPerView={1}
                                    spaceBetween={0}
                                    loop={false}
                                    className={styles.swiper}
                                >
                                    {items.map((item, index) => {
                                        const embedUrl = getEmbedUrl(item.video_url);
                                        const thumbnailUrl = getYouTubeThumbnail(item.video_url);
                                        const isPlaying = playingSlides.has(index);
                                        return (
                                            <SwiperSlide key={index}>
                                                <div className={styles.slide}>
                                                    {item.title && <h3 className={styles.slideTitle}>{item.title}</h3>}
                                                    {item.description && (
                                                        <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                                    )}
                                                    {embedUrl && (
                                                        <div className={`${styles.mediaBlock} ${styles.videoWrapper}`}>
                                                            {isPlaying ? (
                                                                <iframe
                                                                    src={`${embedUrl}?autoplay=1`}
                                                                    title={item.title || `Video ${index + 1}`}
                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                    allowFullScreen
                                                                    style={{ border: 'none' }}
                                                                />
                                                            ) : (
                                                                <div className={styles.thumbnailWrapper} onClick={() => handlePlay(index)}>
                                                                    {thumbnailUrl && (
                                                                        <img
                                                                            src={thumbnailUrl}
                                                                            alt={item.title || `Video ${index + 1}`}
                                                                            className={styles.thumbnailImg}
                                                                        />
                                                                    )}
                                                                    <div className={styles.playBtn}>
                                                                        <svg viewBox="0 0 68 48" width="68" height="48">
                                                                            <path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="#FF0000"/>
                                                                            <path d="M45 24L27 14v20" fill="#fff"/>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {item.testimonial && (
                                                        <div className={`${styles.mediaBlock} ${styles.testimonialCard}`}>
                                                            <div dangerouslySetInnerHTML={{ __html: item.testimonial }} />
                                                        </div>
                                                    )}
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                                {hasMultiple && (
                                    <button
                                        className={`${styles.nextBtn} ${isEnd ? styles.navHidden : ''}`}
                                        onClick={() => swiper?.slideNext()}
                                        aria-label="Next slide"
                                    >
                                        <img src="/site-assets/images/slide-button.png" alt="Next" className={styles.nextBtnImg} />
                                    </button>
                                )}
                            </div>
                        }
                        {bottomContent &&
                            <div className="description pb-5" dangerouslySetInnerHTML={{ __html: bottomContent }} />
                        }
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default CarouselBlogDetail;
